// extracted by mini-css-extract-plugin
export default {"hourlyPrediction":"HourlyPrediction_hourlyPrediction__bK1v1","chartsWrapper":"HourlyPrediction_chartsWrapper__Vq76u","dailyPrediction":"HourlyPrediction_dailyPrediction__YsB0I"};